const BarsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <g id="Bars">
      <path
        id="Vector"
        fill="#000"
        fillOpacity="0.85"
        d="M16.031 3.375H5.766a.14.14 0 0 0-.141.14V4.5c0 .077.063.14.14.14h10.266c.078 0 .14-.063.14-.14v-.984a.14.14 0 0 0-.14-.141m0 4.992H5.766a.14.14 0 0 0-.141.14v.985c0 .078.063.14.14.14h10.266c.078 0 .14-.062.14-.14v-.984a.14.14 0 0 0-.14-.14m0 4.992H5.766a.14.14 0 0 0-.141.141v.984c0 .078.063.141.14.141h10.266c.078 0 .14-.063.14-.14V13.5a.14.14 0 0 0-.14-.14M1.828 4.008a.984.984 0 1 0 1.969 0 .984.984 0 0 0-1.969 0m0 4.992a.984.984 0 1 0 1.969 0 .984.984 0 0 0-1.969 0m0 4.992a.984.984 0 1 0 1.968 0 .984.984 0 0 0-1.968 0"
      ></path>
    </g>
  </svg>
);

export default BarsIcon;
